import { CampaignBlocks, getDefaultBlockStructure, } from "@kvix/shared";
import { Box, Grid, IconButton, makeStyles, TextField, useMediaQuery, useTheme, } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { campaignBlockList } from "..";
import { CardList } from "../../CardList";
import { KvixIcon } from "../../icons";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
import { CommentBlock } from "./CommentBlock";
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: 42,
        background: theme.palette.background.paper,
        [theme.breakpoints.down("xs")]: {
            padding: 42 / 2,
        },
    },
    gridContainer: {
        display: "grid",
        gridTemplateRows: "auto",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gridColumnGap: 72,
    },
    gridComment: {
        flexGrow: 1,
    },
    autoComplete: {
        margin: "20px 0 0",
    },
    commentRow: {
        margin: "20px 0 0",
    },
    gridRemoveButton: {
        marginTop: "auto",
        marginBottom: "auto",
    },
}));
export class CommentsBlock {
    constructor() {
        this.childBlockStructure = getDefaultBlockStructure(CommentBlock);
        this.defaultStructure = {
            name: CampaignBlocks.CommentsBlock,
            subBlocks: [
                this.childBlockStructure,
                this.childBlockStructure,
                this.childBlockStructure,
                this.childBlockStructure,
            ],
        };
        this.Render = (props) => {
            const classes = useStyles();
            const theme = useTheme();
            const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
            return (React.createElement("div", { className: classes.root }, isMobile ? (React.createElement(CardList, null, props.block.subBlocks.map((block, index) => {
                const blockType = campaignBlockList[block.name];
                const blockObject = new blockType();
                return (React.createElement(Box, { key: index, width: 250 },
                    React.createElement(SwiperSlide, null,
                        React.createElement(blockObject.Render, { block: block }))));
            }))) : (React.createElement("div", { className: classes.gridContainer }, props.block.subBlocks.map((block, index) => {
                const blockType = campaignBlockList[block.name];
                const blockObject = new blockType();
                return React.createElement(blockObject.Render, { key: index, block: block });
            })))));
        };
        this.Compose = (props) => {
            var _a;
            const { block } = props;
            const { answers, updateContent } = useContext(AdminCampaignContentContext);
            const [options, setOptions] = useState();
            const [selectedOptions, setSelectedOptions] = useState(null);
            const classes = useStyles();
            useEffect(() => {
                setOptions(answers);
            }, [answers]);
            useEffect(() => {
                if (selectedOptions === null) {
                    if (!options) {
                        return;
                    }
                    const ids = block.subBlocks.map((block) => +block.subTitles[1]);
                    setSelectedOptions(options.filter((option) => {
                        return ids.includes(option.id);
                    }));
                    return;
                }
                const tempBlocks = selectedOptions.map((option) => {
                    const childBlock = {
                        name: CampaignBlocks.CommentBlock,
                        titles: [`${option.user.name.first} ${option.user.name.last}`],
                        subTitles: [`${option.rating}`, `${option.id}`],
                        texts: [option.comment],
                        media: { images: [option.user.imageUrl] },
                    };
                    return childBlock;
                });
                const iterationsLeft = 4 - tempBlocks.length;
                if (iterationsLeft) {
                    for (let i = 0; i < iterationsLeft; i++) {
                        tempBlocks.push(this.childBlockStructure);
                    }
                }
                block.subBlocks = tempBlocks;
                updateContent(block);
            }, [selectedOptions, options]);
            const remove = (id) => {
                setSelectedOptions(selectedOptions.filter((v) => {
                    if (v.id !== id) {
                        return v;
                    }
                }));
            };
            const commentAdminView = useMemo(() => {
                return block.subBlocks
                    .filter((b) => {
                    if (b.subTitles[1] !== "") {
                        return b;
                    }
                })
                    .map((b, index) => {
                    const commentBlock = new CommentBlock();
                    return (React.createElement(Grid, { container: true, direction: "row", key: index, className: classes.commentRow },
                        React.createElement(Grid, { className: classes.gridComment },
                            React.createElement(commentBlock.Render, { block: b })),
                        React.createElement(Grid, { className: classes.gridRemoveButton },
                            React.createElement(IconButton, { onClick: () => remove(+b.subTitles[1]) },
                                React.createElement(KvixIcon.Close, null)))));
                });
            }, [block.subBlocks]);
            const handleOnChange = (value) => {
                if (value) {
                    const tempAnswer = value;
                    const inSelectedOptions = (answer) => {
                        const returnValue = selectedOptions.some((option) => option.id === answer.id);
                        return returnValue;
                    };
                    if (selectedOptions.length < 4 && !inSelectedOptions(tempAnswer)) {
                        setSelectedOptions([...selectedOptions, tempAnswer]);
                    }
                }
            };
            return (React.createElement(React.Fragment, null, (_a = block.subBlocks) === null || _a === void 0 ? void 0 :
                _a.map((subBlock, index) => {
                    return React.createElement("input", { key: index, type: "hidden", required: true, value: subBlock.texts[0] });
                }),
                React.createElement(Autocomplete, { options: options === null || options === void 0 ? void 0 : options.filter((option) => !(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.includes(option))), getOptionLabel: (option) => option.comment, onChange: (event, value) => handleOnChange(value), renderInput: (params) => React.createElement(TextField, Object.assign({}, params)), className: classes.autoComplete }),
                commentAdminView));
        };
    }
}
//# sourceMappingURL=CommentsBlock.js.map